import { type AssessmentBasedRefundEntitlement, type RefundEntitlement } from './RefundEntitlement.types';

export const isAssessmentPolicyWithCurriculumStarted = (
    re: RefundEntitlement<boolean> | null,
): re is AssessmentBasedRefundEntitlement<true> =>
    !!re && re.refundPolicy === 'based_on_assessment_completion' && 'numAssessmentsForPolicy' in re.metadata;
